export default function maskValue(value, start, end, mask_char = '*') {
  if (!value) return '';

  const valueStr = value.toString();
  const length = valueStr.length;

  if (start >= length) {
    return valueStr;
  }

  const prefix = valueStr.slice(0, start);
  let masked;
  let suffix = '';

  if (end >= length) {
    // Mask everything after start
    masked = mask_char.repeat(length - start);
  } else {
    masked = mask_char.repeat(end - start);
    suffix = valueStr.slice(end);
  }

  return prefix + masked + suffix;
}
